import { createSlice } from "@reduxjs/toolkit";
import ApiFunctionalityManagement from "../../api/functionality";

export const settingsSlice = createSlice({
  name: "settings",
  initialState: {
    data: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    setSettings: (state, action) => {
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        error: null,
      };
    },
    setSettingsLoading: (state) => {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    },
    setSettingsError: (state, action) => {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    },
  },
});

export const {
  setSettings,
  setSettingsLoading,
  setSettingsError,
} = settingsSlice.actions;

// ✅ Async thunk
export const fetchSettings = () => async (dispatch) => {
  dispatch(setSettingsLoading());
  try {
    const response = await ApiFunctionalityManagement.get();
    dispatch(setSettings(response.data.settings));
  } catch (error) {
    dispatch(setSettingsError(error.message));
  }
};

// ✅ Selectors
export const selectSettings = (state) => state.settings.data;
export const selectSettingsLoading = (state) => state.settings.isLoading;
export const selectSettingsError = (state) => state.settings.error;

export default settingsSlice.reducer;